'use client'

import React, { createContext, useContext, useState } from 'react'

import {
  DisabledPageScrollContextType,
  DisabledPageScrollProviderProps,
} from '@pearlconvert/ui/providers/disabled-page-scroll/types'

const DisabledPageScrollContext = createContext<DisabledPageScrollContextType>({
  isDisabledPageScroll: false,
  toggleDisabledPageScroll: () => {},
})

const { Provider } = DisabledPageScrollContext

export const DisabledPageScrollProvider: React.FC<
  DisabledPageScrollProviderProps
> = ({ children }) => {
  const [isDisabledPageScroll, setIsDisabledPageScroll] = useState(false)

  const toggleDisabledPageScroll = (newValue: boolean) => {
    if (newValue === isDisabledPageScroll) {
      return
    }

    if (newValue) {
      setIsDisabledPageScroll(true)
      document.body.classList.add('no-scroll')
    } else {
      setIsDisabledPageScroll(false)
      document.body.classList.remove('no-scroll')
    }
  }

  return (
    <Provider value={{ isDisabledPageScroll, toggleDisabledPageScroll }}>
      {children}
    </Provider>
  )
}

export const useDisabledPageScroll = () => useContext(DisabledPageScrollContext)
